import { Avatar, DEFAULT_AVATAR_URL } from '@shared'
import { useUser, useUserState } from '@store'

import styles from './UserAvatar.module.scss'

interface UserAvatarProps {
  size?: number
  className?: string
  lineGradient?: boolean
}

export const UserAvatar = ({ size = 50, className }: UserAvatarProps) => {
  const profile = useUserState()
  const { avatarUrlCached } = useUser()

  return (
    <div className={styles.container}>
      {/* {lineGradient && (
        <div className={styles.lineGradientContainer}>
          <LineGradient className={styles.lineGradientLeft} />
        </div>
      )} */}
      <Avatar
        srcAvatar={avatarUrlCached || DEFAULT_AVATAR_URL}
        srcEffect={profile?.avatarEffect || ''}
        size={size}
        className={className}
      />
      {/* {lineGradient && (
        <div className={styles.lineGradientContainer}>
          <LineGradient className={styles.lineGradient} />
        </div>
      )} */}
    </div>
  )
}
